<template>
  <div :class="{ 'resume-main': !updating, 'updating': updating }">
    <div v-if="!updating" class="resume-content">
      <section id="section-step1" @mouseenter="destacLik">
        <h5 class="mb-0">{{ $t('caracteristicas-do-indicador') }}</h5>
        <p class="mb-1">{{ $t('passo-1') }}</p>
        <div>
          <p><strong>{{ $t('nome-do-indicador-1') }} </strong> {{ indicatorName }}</p>
          <p><strong>{{ $t('unidade-de-medida-0') }} </strong> {{ unitMensure }}</p>
          <p><strong>{{ $t('tipo-do-indicador-0') }} </strong> {{ calcType }}</p>
          <p><strong>{{ $t('horario-do-calculo-0') }} </strong> {{ calcDateTime }}</p>
        </div>
        <hr>
      </section>
      <section id="section-step2" @mouseenter="destacLik">
        <h5 class="mb-0">{{ $t('referencia-real-do-indicador') }}</h5>
        <p class="mb-1">{{ $t('passo-2') }}</p>
        <div v-if="!allValueEmpty && calcValueAreOk && !valueNotFound">
          <div class="upper-title">
            <div class="content-title">
              <label>{{ $t('classe-de-valores') }}</label>
            </div>
            <div v-if="valueAdvancedCalcs">
              <p style="color: #FFAA33;">
                {{ $t("calculos-avancados-favor") }}
              </p>
            </div>
            <div v-if="!valueAdvancedCalcs && !valueNotFound">
              <p v-if="valueOnline"><strong>{{ $t('online') + ":" }}</strong> {{ valueOnline }}</p>
              <p v-if="valueDay"><strong>{{ $t('dia') + ":" }}</strong> {{ valueDay }}</p>
              <p v-if="valueWeek"><strong>{{ $t('semana') + ":" }}</strong> {{ valueWeek }}</p>
              <p v-if="valueMonth"><strong>{{ $t('mes-1') }} </strong> {{ valueMonth }}</p>
              <p v-if="valueHarvest"><strong>Safra: </strong> {{ valueHarvest }}</p>
            </div>
          </div>
          <div v-if="!valueAdvancedCalcs" class="upper-title">
            <div class="content-title">
              <label>{{ $t('fonte-de-dados') }}</label>
            </div>
            <p v-for="source, i in indRealList" :key="i">
              <strong>{{ source.name + ":" }} </strong>
              <label class="ml-1 mb-0" v-for="variable, j in source.variables" :key="j">{{ (typeof source.variables ==
                'object' && variable.name ? (`${variable.name} = ${variable.tag}${( source.variables && source.variables.length == j + 1 ? "" :
                  ", ")}`) : variable) }}
              </label>
            </p>
          </div>
        </div>
        <div v-else>
          <b-icon class="icon-button-pentagro mr-2 mt-1" :title="showValueError" icon="exclamation-triangle"
            @click="call('step-2')">
          </b-icon>
        </div>
        <hr>
      </section>
      <section id="section-step3" @mouseenter="destacLik">
        <h5 class="mb-0">{{ $t('referencia-prevista-do-indicador') }}</h5>
        <p class="mb-1">{{ $t('passo-3') }}</p>
        <div v-if="!allTargetEmpty && calcTargetAreOk">
          <div class="upper-title">
            <div class="content-title">
              <label>{{ $t('classe-de-valores') }}</label>
            </div>
            <div v-if="targetAdvancedCalcs">
              <p style="color: #FFAA33;">
                Cálculos avançados, favor entrar em contato com o suporte Pentagro para mais informações.
              </p>
            </div>
            <div v-if="!targetAdvancedCalcs">
              <p v-if="targetOnline"><strong>Online: </strong> {{ targetOnline }}</p>
              <p v-if="targetDay"><strong>{{ $t('dia') + ": " }} </strong> {{ targetDay }}</p>
              <p v-if="targetWeek"><strong>{{ $t('semana') + ": " }} </strong> {{ targetWeek }}</p>
              <p v-if="targetMonth"><strong>{{ $t('mes-1') }} </strong> {{ targetMonth }}</p>
              <p v-if="targetHarvest"><strong>{{ $t('safra-0') + ": " }} </strong> {{ targetHarvest }}</p>
            </div>
          </div>
          <div v-if="!targetAdvancedCalcs" class="upper-title">
            <div class="content-title">
              <label>{{ $t('fonte-de-dados') }}</label>
            </div>
            <p v-for="source, i in indPrevList" :key="i">
              <strong>{{ source.name + ": " }} </strong>
              <label class="ml-1 mb-0" v-for="variable, j in source.variables" :key="j">
                {{ (typeof source.variables == 'object' && variable.name ?
                  (`${variable.name} = ${variable.tag}${( source.variables && source.variables.length == j + 1 ? "" : ", ")}`) :
                  variable) }}
              </label>
            </p>
          </div>
        </div>
        <div v-else>
          <b-icon class="icon-button-pentagro mr-2 mt-1" :title="showTargetError" icon="exclamation-triangle"
            @click="call('step-3')">
          </b-icon>
        </div>
        <hr>
      </section>
      <section id="section-step4" @mouseenter="destacLik">
        <h5 class="mb-0">{{ $t('posicionamento-do-indicador') }}</h5>
        <p class="mb-1">{{ $t('passo-4') }}</p>
        <div v-if="this.hasPositions">
          <p><strong>{{ $t('quantidade-alocada') }} </strong> {{ this.note.allocatedAmount }}</p>
          <p><strong>{{ $t("vinculado-a-tela-de-monitoramento") }}</strong> {{ this.note.linkedToMonitoringScreen }}</p>
          <p><strong>{{ $t('nova-tela-de-monitoramento') }} </strong> {{ this.note.newScreenMonitoring }}</p>
          <p><strong>{{ $t('nova-area-de-monitoramento') }} </strong> {{ this.note.newAreaScreen }}</p>
        </div>
        <div v-else>
          <b-icon class="icon-button-pentagro mr-2 mt-1" :title="$t('nao-ha-posicao-configurada-para-este-indicador')"
            icon="exclamation-triangle" @click="call('step-4')">
          </b-icon>
        </div>
        <hr>
      </section>
      <section id="section-step5" @mouseenter="destacLik">
        <h5 class="mb-0">{{ $t('gatilhos-configurados') }}</h5>
        <p class="mb-1">{{ $t('passo-5') }}</p>
        <p><strong>{{ $t('quantidade-de-configuracoes-criadas') }}</strong> {{ triggersConfigList.length }}</p>
        <div v-if="triggersConfigList.length" class="resume-triggers">
          <div v-for="tgc, index in triggersConfigList" :key="index">
            <div class="upper-title">
              <div class="content-title">
                <label>{{ tgc.name }}</label>
              </div>
              <div class="content-triggers" v-for="trigger, index in tg[tgc.key]" :key="index">
                <div class="active-trigger">
                  <span :title="(trigger.active ? $t('gatilho-ativo') : $t('gatilho-desativado'))"
                    :class="{ 'switch-trigger': true, 'active': trigger.active }">
                  </span>
                  <p><strong>{{ trigger.triggercode }} - {{ triggerInfo.get(trigger.triggercode).name }}</strong></p>
                  <!-- <p>{{ trigger.active ? 'Ativo' : 'Desativado' }}</p> -->
                </div>
                <p v-if="trigger.triggercode == 'VLV'">{{ $t('valor-minimo-manual') }} {{ trigger.minActive ?
                  `${$t("yes")} : ${trigger.minValue}` : $t("no") }}</p>
                <p v-if="trigger.triggercode == 'VLV'">{{ $t('valor-maximo-manual') }} {{ trigger.maxActive ?
                  `${$t("yes")} : ${trigger.maxValue}` : $t("no") }}</p>
                <p v-if="trigger.triggercode == 'VLT' && trigger.active">{{ $t('valor-maximo-manual') }}: {{
                  trigger.minutes ? trigger.minutes : 0 }}</p>
                <p v-if="trigger.triggercode != 'VLV' &&
                  trigger.triggercode != 'VLT' &&
                  trigger.triggercode != 'ALT' &&
                  trigger.triggercode != 'ALD' &&
                  trigger.active">
                  {{ $t("nao-conformidades") }} {{ trigger.unconformities ? trigger.unconformities : 0 }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p>{{ $t('nao-ha-gatilhos-configurados') }}</p>
        </div>
        <hr>
      </section>
      <section id="section-step6" @mouseenter="destacLik">
        <b-icon id="skip-indicator" class="icon-button-pentagro mr-2 mt-1" title="Guardar o indicador e iniciar outro"
          icon="upload" @click="saveStash"></b-icon>
        <b-icon id="finish-indicator" v-if="!canShowErrors" class="icon-button-pentagro mr-2 mt-1"
          :title="$t('concluir-alteracoes-e-aplicar')" icon="card-checklist" @click="askBuildIndicator">
        </b-icon>
        <p v-else> {{ this.hasProblems }}</p>
      </section>
    </div>
    <div v-if="!updating" class="resume-links">
      <div>
        <a @click="destacLik({ target: { id: 'section-step1' } })" class="mt-0" href="#section-step1">{{
          $t('caracteristicas')
        }}</a>
        <a @click="destacLik({ target: { id: 'section-step2' } })" href="#section-step2">{{ $t('referencia-real') }}</a>
        <a @click="destacLik({ target: { id: 'section-step3' } })" href="#section-step3">{{ $t('referencia-prevista')
        }}</a>
        <a @click="destacLik({ target: { id: 'section-step4' } })" href="#section-step4">{{ $t('posicionamento') }}</a>
        <a @click="destacLik({ target: { id: 'section-step5' } })" href="#section-step5">{{ $t('gatilhos') }}</a>
        <a @click="destacLik({ target: { id: 'section-step6' } })" href="#section-step6">{{ $t('finalizar') }}</a>
      </div>
    </div>
    <ApplyingSettingsVue v-else />
    <b-modal id="askApplyEdition" :title="$t('atention')" ok-variant="danger" :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="buildIndicator">{{ $t('ask-build-indicator') }}
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Mediator from '../../utilities/Mediator'
import ApplyingSettingsVue from './ApplyingSettings.vue'
import { updateMyUserPermission, urlMainAPI } from '../../../../../global'

export default {
  name: "Indicator-Resume",
  components: { ApplyingSettingsVue },

  data() {
    return {
      step: "step-6",
      indicatorName: Mediator.indicator.indicatorName,
      operatingRange: Mediator.indicator.operatingRange,
      criticalRange: Mediator.indicator.criticalRange,
      reliabilityThreshold: Mediator.indicator.reliabilityThreshold,
      reliabilityCritical: Mediator.indicator.reliabilityCritical,
      unitMensure: Mediator.indicator.unitMensure,
      calcType: Mediator.indicator.calcType,
      calcDateTime: Mediator.indicator.calcDateTime,
      indRealList: Mediator.indicator.indRealList,
      indPrevList: Mediator.indicator.indPrevList,
      valueOnline: Mediator.indicator.valueOnline,
      valueDay: Mediator.indicator.valueDay,
      valueWeek: Mediator.indicator.valueWeek,
      valueMonth: Mediator.indicator.valueMonth,
      valueHarvest: Mediator.indicator.valueHarvest,
      targetOnline: Mediator.indicator.targetOnline,
      targetDay: Mediator.indicator.targetDay,
      targetWeek: Mediator.indicator.targetWeek,
      targetMonth: Mediator.indicator.targetMonth,
      targetHarvest: Mediator.indicator.targetHarvest,
      isNew: Mediator.indicator.isNew,
      positions: Mediator.indicator.positions,
      createScreen: Mediator.indicator.createScreen,
      triggerInfo: new Map(),
      tg: Mediator.indicator.triggers,
      triggersConfigList: [],
      note: Mediator.indicator.note,
      updating: false,
      targetAdvancedCalcs: false,
      valueAdvancedCalcs: false,
      valueNotFound: false,
    }
  },

  computed: {
    allValueEmpty() {
      return !(!!this.valueOnline || !!this.valueDay || !!this.valueWeek || !!this.valueMonth || !!this.valueHarvest);
    },

    allTargetEmpty() {
      return !(!!this.targetOnline || !!this.targetDay || !!this.targetWeek || !!this.targetMonth || !!this.targetHarvest);
    },

    targetParenthesesOk() {
      return this.parenthesesOk(this.targetOnline) &&
        this.parenthesesOk(this.targetDay) &&
        this.parenthesesOk(this.targetWeek) &&
        this.parenthesesOk(this.targetMonth) &&
        this.parenthesesOk(this.targetHarvest)
    },

    targetOperatorsAreOk() {
      return this.operatorsAreOk(this.targetOnline) &&
        this.operatorsAreOk(this.targetDay) &&
        this.operatorsAreOk(this.targetWeek) &&
        this.operatorsAreOk(this.targetMonth) &&
        this.operatorsAreOk(this.targetHarvest)
    },

    valueParenthesesOk() {
      return this.parenthesesOk(this.valueOnline) &&
        this.parenthesesOk(this.valueDay) &&
        this.parenthesesOk(this.valueWeek) &&
        this.parenthesesOk(this.valueMonth) &&
        this.parenthesesOk(this.valueHarvest)
    },

    valueOperatorsAreOk() {
      return this.operatorsAreOk(this.valueOnline) &&
        this.operatorsAreOk(this.valueDay) &&
        this.operatorsAreOk(this.valueWeek) &&
        this.operatorsAreOk(this.valueMonth) &&
        this.operatorsAreOk(this.valueHarvest)
    },

    calcValueAreOk() {
      return this.valueParenthesesOk && this.valueOperatorsAreOk
    },

    calcTargetAreOk() {
      return this.targetParenthesesOk && this.targetOperatorsAreOk
    },

    hasPositions() {
      return this.positions.length > 0
    },

    showValueError() {
      let error = !this.valueParenthesesOk ? " Algo errado com os parênteses." : ""
      error += !this.valueOperatorsAreOk ? " Algo errado com os operadores aritméticos." : ""
      return error ? error : this.$t('e-necessario-ao-menos-uma-referencia-real-para-o-indicador')
    },

    showTargetError() {
      let error = !this.targetParenthesesOk ? " Algo errado com os parenteses." : ""
      error += !this.targetOperatorsAreOk ? " Algo errado com os operadores aritméticos." : ""
      return error ? error : this.$t('e-necessario-ao-menos-uma-referencia-prevista-para-o-indicador')
    },

    canShowErrors() {
      let error = this.allValueEmpty || !this.calcValueAreOk;
      error = (this.allTargetEmpty || !this.calcTargetAreOk) || error;
      error = !this.hasPositions || error;
      return error;
    },

    hasProblems() {
      let error = this.allValueEmpty || !this.calcValueAreOk ? this.$t("passo-2") + ", " : "";
      error += this.allTargetEmpty || !this.calcTargetAreOk ? this.$t("passo-3") + ", " : "";
      error += !this.hasPositions ? this.$t("passo-4") + ", " : "";
      error = error.substring(0, error.length - 2);
      return `${this.$t("para-prosseguir-resolva-conflitos")} ${error}.`
    }
  },

  methods: {

    parenthesesOk(expression) {
      if (!expression) return true
      let bracketLeft = expression.match(/\(/g);
      let bracketRight = expression.match(/\)/g);
      if (bracketLeft && bracketRight) {
        return bracketLeft.length == bracketRight.length
      }
      return !bracketLeft && !bracketRight
    },

    operatorsAreOk(expression) {
      let operations = ["+", "*", "/", "-"]
      if (!expression) return true
      for (const op of operations) {
        let lastElement = expression.slice(expression.length - 1, expression.length)
        if (lastElement.trim() == op) {
          return false
        }
      }
      return true;
    },

    destacLik(event) {
      let target = event.target
      document.querySelectorAll(".resume-links a").forEach(a => a.classList.remove("visible"))
      document.querySelector(`a[href="#${target.id}"]`).classList.add("visited")
      document.querySelector(`a[href="#${target.id}"]`).classList.add("visible")
    },

    initTriggerInfo() {
      Mediator.data.indicatorTriggers.filter(i => i.triggercode != "MAN")
        .forEach(info => {
          this.triggerInfo.set(info.triggercode, info)
        })
    },

    call(step) {
      document.getElementById(step).click();
    },

    saveStash() {
      Mediator.notify(null, "save-stash")
    },

    askBuildIndicator() {
      this.$bvModal.show("askApplyEdition");
    },

    buildIndicator() {
      this.updating = true;
      Mediator.notify(null, "updating-indicator");
      axios.post(`${urlMainAPI}/updateindicator`, Mediator.indicator.getStash()).then(res => {
        if (res.status == 200) {
          updateMyUserPermission(axios, this.$store)
          Mediator.notify(null, "stash-aplied");
        }
      }).catch(error => {
        Mediator.notify(null, "stash-error");
        console.error(error)
      })
    }
  },

  beforeMount() {
    console.log(Mediator.indicator)
    this.initTriggerInfo()
    console.log(Mediator.indicator)
    this.triggersConfigList = Mediator.triggers.getTriggerConfigList()
  },

  mounted() {
    console.log(Mediator.indicator)
    this.targetAdvancedCalcs = Mediator.checkAdvancedCalcs(Mediator.indicator, "target");
    this.valueAdvancedCalcs = Mediator.checkAdvancedCalcs(Mediator.indicator, "value");

    let collectorsFound = Mediator.indicator.indRealList.filter(ind => ind.name != "NOTFOUND");
    this.valueNotFound = collectorsFound.length == 0
  },
}
</script>

<style scoped>
.resume-main {
  width: 100%;
  display: grid;
  grid-template-columns: calc(100% - 175px) 175px;
  gap: 8px;
}

.resume-links {
  padding: 8px;
  background-color: #fbfbfb;
  box-shadow: 0 0 3px #00000020;
  border-radius: 2px;
  font-weight: 600;
}

.resume-links>div {
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 8px;
}

#section-step6 {
  display: flex;
  justify-content: space-between;
}

.resume-links a {
  color: #00000099;
  padding: 0 8px;
  position: relative;
  margin-top: 10px;
}

a.visited {
  color: #00A39F;
  text-decoration: none;
  background-size: 100% 4px;
}

a.visible {
  color: #ff5f00;
}

.resume-links a:hover,
.resume-links a:focus {
  color: #ff5f00;
  text-decoration: none;
  background-size: 100% 4px;
}

a.visible::before,
.resume-links a::before {
  content: '';
  position: absolute;
  margin-bottom: 2px;
  width: 100%;
  height: 1.75px;
  border-radius: 4px;
  background-color: #ff5f00;
  bottom: 0;
  left: 0;
  transform-origin: right;
  transform: scaleX(0);
  transition: transform .3s ease-in-out;
}

a.visible::before,
.resume-links a:hover::before {
  transform-origin: left;
  transform: scaleX(1);
}

.upper-title {
  border: 1px solid #00000020;
  border-radius: 4px;
  padding: 0 8px;
  margin-top: 16px;
}

.upper-title p {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.resume-triggers .upper-title {
  min-height: 560px;
}

.resume-content label,
.resume-content p {
  margin-bottom: 5px;
}

.content-triggers {
  margin: 10px 0 0 0;
}

.active-trigger>p,
.content-triggers>p,
.content-triggers:nth-child(2) {
  margin: 0
}

.content-title {
  position: relative;
  top: -16px;
  margin-bottom: -14px !important;
}

.content-title>label {
  display: inline;
  position: relative;
  padding: 2px 4px 0px 4px;
  background-color: #fff;
  box-shadow: 0 0 5px #fff;
  font-size: 0.8rem;
  border-radius: 2px;
  font-weight: 600;
}

.resume-content>section>p,
.resume-content>section>div {
  margin-left: 8px;
}

.resume-triggers {
  display: grid;
  grid-template-columns: calc(50% - 4px) calc(50% - 4px);
  gap: 8px;
}

.active-trigger {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.switch-trigger {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #999;
  background-color: #bbb;
  margin: 0 4px 0 0;
  cursor: default;
}

.switch-trigger.active {
  border: 1px solid #0b0;
  background-color: #0f0;
}
</style>